import {draftEventPreviewUrlQueryParamName} from '@wix/wix-events-commons-statics'
import {IWixAPI} from '@wix/yoshi-flow-editor'

export const getDraftToken = (wixCodeApi: IWixAPI) => {
  const {query} = wixCodeApi.location
  return query[draftEventPreviewUrlQueryParamName]
}
